import { ChangeDetectionStrategy, Component, inject, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DialogDefaultData, MessageLevel } from 'src/app/interfaces';
import { NotificationState } from '../../notifications.state';
import { DialogActionTypes } from '../dialogs.enum';

export const DIALOG_DEFAULT_DATA = new InjectionToken<DialogDefaultData>(`DIALOG_DEFAULT_DATA`);

@Component({
  selector: 'app-response-modal',
  templateUrl: './dialog-default.component.html',
  styleUrls: ['./dialog-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogDefaultComponent extends NotificationState {
  protected notificationLevel: MessageLevel = 'INFO';

  public readonly dialog = inject(DIALOG_DEFAULT_DATA);
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(_data: string): void {
    // Simply ignore
  }
}
